import React from "react";
import PopupHeader from "../molecules/PopupHeader";
import AddHistoryFooter from "../molecules/AddHistoryFooter";
import AddHistoryBody from "../molecules/AddHistoryBody";
import useAddHistory from "../../hooks/useAddHistory";


const AddHistory = ({ subModalMount, closeModal, closeSubModal }) => {

  const {
    handleInputChange,
    formData,
    containerRef,
    closeModalConfirm,
    showCustomerCodeInput,
    screenShot,
    screenShotReady,
    summaryImageElement
  } = useAddHistory();

  const screenShotProps = { screenShot, screenShotReady, summaryImageElement };




  return (
    <div className={"detail-design-history"} ref={containerRef}>
        <PopupHeader title={"Add New Design History"}
                     callback={() => closeModalConfirm(subModalMount, closeModal, closeSubModal)}
        />
        <AddHistoryBody {...screenShotProps}
                        handleInputChange={handleInputChange}
                        formData={formData}
        />
        <AddHistoryFooter subModalMount={subModalMount}
                          closeModal={closeModal}
                          closeSubModal={closeSubModal}
                          showCustomerCodeInput={showCustomerCodeInput}
        />


    </div>
  )
}

export default AddHistory;
